import { render, staticRenderFns } from "./Mondrian.vue?vue&type=template&id=132c5256&scoped=true&"
import script from "./Mondrian.vue?vue&type=script&lang=js&"
export * from "./Mondrian.vue?vue&type=script&lang=js&"
import style0 from "./Mondrian.vue?vue&type=style&index=0&id=132c5256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132c5256",
  null
  
)

export default component.exports